// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"408ad1a7","455":"3fc2b2c7","977":"54e83d15"}[chunkId] + ".chunk.js";
};